// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { useTranslation } from "react-i18next";
import { CloseOutlined } from "@ant-design/icons";

export interface MessagePopupErrorProps {
  messageText?: string;
  translate: boolean;
  hideRef?: { hide: () => void };
}

const MessagePopupError: React.FunctionComponent<MessagePopupErrorProps> = (
  props: MessagePopupErrorProps
) => {
  const { messageText, translate, hideRef } = props;
  const { t } = useTranslation();
  return (
    <span
      onClick={() => {
        if (hideRef && hideRef.hide) {
          hideRef.hide();
        }
      }}
      className="cursor-pointer"
    >
      {translate ? t(messageText ? messageText : "") : messageText}
      <div className="btn-close-message cursor-pointer">
        <CloseOutlined className="font-icon" />
      </div>
    </span>
  );
};

export default MessagePopupError;
